module.exports = __webpack_public_path__ + "static/media/target.556d756c.svg";